import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HasIdClass;
function HasId() {
  if (HasIdClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'HasId');
    HasIdClass = $;
  }
  return HasIdClass;
}
function compareTo_0(other) {
  return compareTo(this.get_raw_18ix4x_k$(), other.get_raw_18ix4x_k$());
}
var TypedIdClass;
function TypedId() {
  if (TypedIdClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'TypedId', VOID, VOID, [Comparable()]);
    TypedIdClass = $;
  }
  return TypedIdClass;
}
//region block: exports
export {
  HasId as HasId24qpfucecockd,
  compareTo_0 as compareTo1g8l26b65emtd,
  TypedId as TypedIdexo9ecsepo30,
};
//endregion

//# sourceMappingURL=HasId.mjs.map
